export interface FinancialRiskFilterType {
  selectedRiskLevels: server.dto.FinancialRiskLevels[]
}

export const getSortedRiskLevels = (filter: FinancialRiskFilterType) => {
  const order: server.dto.FinancialRiskLevels[] = [
    "unknown", "fullTrust", "lowRisk", "highRisk", "blocklist"
  ];
  return [...filter.selectedRiskLevels]
    .sort((a, b) => {
      const indexA = order.findIndex(value => value === a);
      const indexB = order.findIndex(value => value === b);
      return indexA - indexB;
    });
};

export const getLabel = (riskLevel: server.dto.FinancialRiskLevels) => {
  return serverReference.financialRiskLevels.find(
    (lvl) => lvl.value === riskLevel
  )?.text;
};

export const getColor = (riskLevel: server.dto.FinancialRiskLevels) => {
  return serverReference.financialRiskLevels.find(
    (lvl) => lvl.value === riskLevel
  )?.hexColor;
};

export const initialFinancialRiskFilter: FinancialRiskFilterType = {
  selectedRiskLevels: []
};
